/* eslint-disable react-refresh/only-export-components -- co-located helpers/constants */
import type { ChipProps } from '@mui/material';
import { Chip } from '@mui/material';
import type { DeviceInventoryStatus } from '@cnapse/shared/schemas.js';

export type DeviceInventoryStatusChipColor = Exclude<
  ChipProps['color'],
  'primary' | 'secondary' | undefined
>;

export const DEVICE_INVENTORY_STATUS_LABELS: Record<DeviceInventoryStatus, string> = {
  'in-stock': 'In Stock',
  allocated: 'Allocated',
  shipped: 'Shipped',
  claimed: 'Claimed',
  active: 'Active',
  returned: 'Returned',
  retired: 'Retired',
};

export const DEVICE_INVENTORY_STATUS_CHIP_COLORS: Record<
  DeviceInventoryStatus,
  DeviceInventoryStatusChipColor
> = {
  'in-stock': 'default',
  allocated: 'warning',
  shipped: 'info',
  claimed: 'info',
  active: 'success',
  returned: 'warning',
  retired: 'error',
};

export function getDeviceInventoryStatusLabel(status: string): string {
  return DEVICE_INVENTORY_STATUS_LABELS[status as DeviceInventoryStatus] ?? status;
}

export function getDeviceInventoryStatusChipColor(status: string): DeviceInventoryStatusChipColor {
  return DEVICE_INVENTORY_STATUS_CHIP_COLORS[status as DeviceInventoryStatus] ?? 'default';
}

interface DeviceInventoryStatusChipProps extends Omit<ChipProps, 'label' | 'color'> {
  status: string;
  /** Optional override (e.g. "Active: 3" for availability summaries). */
  label?: string;
}

/** Standard device inventory lifecycle chip — matches Device Inventory and detail pages. */
export function DeviceInventoryStatusChip({
  status,
  size = 'small',
  label,
  ...props
}: DeviceInventoryStatusChipProps) {
  return (
    <Chip
      {...props}
      size={size}
      label={label ?? getDeviceInventoryStatusLabel(status)}
      color={getDeviceInventoryStatusChipColor(status)}
    />
  );
}
